import React from 'react';
import { CardTypes } from '../../libraries/CardThemes';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Card.scss';
const rootClassName = 'component-card';

interface CardProps {
  theme?: CardTypes;
  caption?: string;
  label?: string;
  helperText?: string;
}

export default function Card(props: CardProps) {
  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        `${rootClassName}-${props.theme}`
      ])}
    >
      <div className={`${rootClassName}-caption`}>{props.caption}</div>
      <div className={`${rootClassName}-label`}>{props.label}</div>
      <div className={`${rootClassName}-helper-text`}>{props.helperText}</div>
    </div>
  );
}

Card.defaultProps = {
  theme: CardTypes.White
};
